<div class="self-ins-app">
  <ng-progress [color]="'white'" [thick]="true"></ng-progress>
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
  <a (click)="logout()" *ngIf="isAuthorized" title="Log Out" class="logout">
    <img src="../assets/logout.svg" alt="logout">
  </a>
</div>
